import axios from 'axios';
import evn  from '@/utils/evn.js';

axios.defaults.baseURL =  evn.baseURL;

const service = axios.create({
    timeout: 40000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
    },
})
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        return res
    },
    error => {
    }
)
export default service
